module.exports = __webpack_public_path__ + "static/media/spu_menu.da92107d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/spu_menu.svg
// module id = 474
// module chunks = 0